import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ReportDomainService {
  constructor() {}

  createWordName(initialName: string | null, reportId: string) {
    const match = initialName?.match(/filename="?([^";]+)"?/);
    return match ? match[1] : `${reportId}.docx`;
  }
}
